<template>
  <Form
    v-slot="{ meta, errors }"
    @submit="handleSubmit"
    :initial-values="pick(customerInfo, ['phone', 'email'])"
  >
    <div class="mb-3">
      <label for="phone" class="form-label">
        {{ $t("ticket.form.labels.phone") }}
      </label>
      <Field
        :class="['form-control'].concat(errors['phone'] ? ['is-invalid'] : [])"
        :label="$t('ticket.form.labels.phone').toLowerCase()"
        name="phone"
        rules="phone"
        id="phone"
        autocomplete="off"
      />
      <ErrorMessage name="phone" class="invalid-feedback" />
    </div>

    <div class="mb-3">
      <label for="email" class="form-label">
        {{ $t("ticket.form.labels.email") }}
      </label>
      <Field
        :class="['form-control'].concat(errors['email'] ? ['is-invalid'] : [])"
        :label="$t('ticket.form.labels.email').toLowerCase()"
        name="email"
        rules="email"
        id="email"
        autocomplete="off"
      />
      <ErrorMessage name="email" class="invalid-feedback" />
    </div>

    <div class="mb-3">
      <label for="message" class="form-label">
        {{ $t("ticket.form.labels.message") }}
      </label>
      <Field
        :class="
          ['form-control'].concat(errors['message'] ? ['is-invalid'] : [])
        "
        :label="$t('ticket.form.labels.message').toLowerCase()"
        name="message"
        rules=""
        id="message"
        autocomplete="off"
        as="textarea"
      />
      <ErrorMessage name="message" class="invalid-feedback" />
    </div>

    <div class="mdr-contacts-modal-footer flex-column">
      <button
        :disabled="!meta.valid || isDisabled"
        type="submit"
        class="btn btn-success mdr-call-button"
      >
        {{ $t("ticket.form.buttons.submit") }}
      </button>
      <button
        @click="handleCancelClick"
        :disabled="isDisabled"
        type="button"
        class="btn btn-secondary mdr-cancel-call"
      >
        {{ $t("ticket.form.buttons.cancel") }}
      </button>
    </div>
  </Form>
</template>

<script lang="ts">
import { useStore } from "vuex";
import { computed, ref } from "vue";
import _ from "lodash";
import { Form, Field, ErrorMessage, FormActions } from "vee-validate";
import { IncidentDTO } from "@moderrotech/servers-communication-library/src/types";

export default {
  components: { Form, Field, ErrorMessage },
  setup() {
    const store = useStore();

    const customerInfo = computed(() => store.getters["metadata/customerInfo"]);
    const incident = computed((): IncidentDTO => store.state.incident.incident);

    const isDisabled = ref(false);

    return {
      customerInfo,
      isDisabled,
      handleSubmit: (
        values: { [k: string]: string },
        actions: FormActions<any>
      ) => {
        isDisabled.value = true;

        store.dispatch("tickets/create", {
          incidentUuid: incident.value.id,
          payload: _.pickBy(values, v => !!v),
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      },
      handleCancelClick: () => {
        isDisabled.value = true;

        store.dispatch("incident/close", {
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      },
      ..._.pick(_, "pick")
    };
  }
};
</script>

<style lang="scss"></style>
